"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.failContactEnrichment = exports.cancelContactEnrichment = exports.completeContactEnrichment = exports.researchContactEnrichment = void 0;

var _contactEnrichment = require("./contactEnrichment.types");

/**
 * Start waiting for the contact enrichment research.
 *
 * @param {number} enrichmentId - Id of enrichment that's created with contact.
 * @returns {{meta: number, type: string}}
 */
var researchContactEnrichment = function researchContactEnrichment(enrichmentId) {
  return {
    type: _contactEnrichment.CONTACT_ENRICHMENT.RESEARCH,
    payload: enrichmentId
  };
};
/**
 * Dispatched when research finish successfully.
 *
 * @param {Array<object>} profiles - Researched profiles.
 * @returns {{payload: Array<object>, type: string}}
 */


exports.researchContactEnrichment = researchContactEnrichment;

var completeContactEnrichment = function completeContactEnrichment(profiles) {
  return {
    type: _contactEnrichment.CONTACT_ENRICHMENT.COMPLETE,
    payload: profiles
  };
};
/**
 * Cancel waiting for contact enrichment research.
 * Usually called when sidebar closing.
 *
 * @returns {{type: string}}
 */


exports.completeContactEnrichment = completeContactEnrichment;

var cancelContactEnrichment = function cancelContactEnrichment() {
  return {
    type: _contactEnrichment.CONTACT_ENRICHMENT.CANCEL
  };
};
/**
 * Called when research finish with failure.
 * Usually failure is request with already finished and saved enrichment id.
 *
 * @returns {{type: string}}
 */


exports.cancelContactEnrichment = cancelContactEnrichment;

var failContactEnrichment = function failContactEnrichment() {
  return {
    type: _contactEnrichment.CONTACT_ENRICHMENT.FAILED
  };
};

exports.failContactEnrichment = failContactEnrichment;